const timeSheet = {
  eventName: "أسم الفاعلية",
  startDate: "تاريخ البدء",
  endDate: "تاريخ الانتهاء",
  type: "نوع الفاعلية",
  link: "رابط التقرير",
  status: "الحالة",
  listTimeSheetBreadcrumb: "قائمة ساعات عمل الفاعليات",
  search: "ابحث باستخدام اسم الفعاليه",
  role: "الوظيفة",
  attendanceReport: "تقرير الحضور",
  placeholder: "لا يوجد تقارير",
  date: "التاريخ",
  applicantName: "اسم المتقدم",
  checkin: "وقت تسجيل الوصول",
  checkout: "وقت تسجيل الخروج",
  checkinPlaceHolder: "ادخل وقت تسجيل الدخول",
  checkoutPlaceHolder: "ادخل وقت تسجيل الخروج",
  datePlaceholder: "ادخل تاريخ تسجييل الدخول",
  removed: "تمت الإزالة",
  assigned: "تم التعيين",
  removedPlaceholder: "المتقدمين",
  EditStatus: "تعديل الحالة ل",
  addStatus: "اضف التوقيت",
  addStatusFor: "اضف التوقيت ل ",
  searchByApplicant: "ابحث باستخدام اسم المتقدم",
  payroll: "الراتب المتوقع",
  numberOfWorkingDays: "عدد أيام العمل",
  dailyReport: {
    name: "تقرير الفاعليه اليومي",
    workingHours: "إجمالي ساعات العمل",
    endDateValidation: "لا يمكن أن يكون تاريخ الانتهاء قبل تاريخ البدء",
  },
  monthlyReport: {
    name: "تقرير الفاعليه الشهري",
    workingHours: " إجمالي ساعات العمل شهريا",
    month: "شهر",
    checkoutStatus: "حالة الخروج",
    checkoutStatusPending: "قيد الانتظار",
    automaticCheckout: "خروج تلقائي",
    selfCheckout: "خروج ذاتي",
  },
  applicantReport: {
    name: "تقرير مقدم الطلب",
    workingHours: "ساعات العمل اليوميه",
    shiftsTab: "الورديات",
    trainingsTab: "التدريبات",
    addTrainingCheckin: "إضافة تسجيل حضور تدريب",
    addTrainingCheckinFor: "إضافة تسجيل حضور تدريب لـ",
    editTrainingStatusFor: "تعديل حالة التدريب لـ",
    trainingHoursPerDay: "ساعات التدريب/اليوم",
  },
  deleteMsg: " هل انت متاكد من حذف التقرير ؟ ",
  exportBtn: "تصدير التقارير إلى ملف اكسل",
  selectColumnsToExport: "اختر الأعمدة المرغوبة ليتم تصديرها",
  exportErr: "يجب أن تختار عمودا واحدا علي الأقل",
  dailyPayroll: "الراتب/اليوم",
  trainingDays: "أيام التدريب",
  trainingPay: "راتب التدريب",
  dailyExportSheet: {
    nameAr: "الاسم بالعربية",
    nameEn: "الاسم بالانجليزية",
    role: "الوظيفة",
    nationalIqama: "رقم الهوية/رقم الإقامة",
    nationality: "الهوية",
    selfCheckoutDates: "مواعيد الخروج الذاتي",
    automaticCheckoutDates: "مواعيد الخروج التلقائي",
    mobile: "رقم الهاتف المحمول",
    email: "البريد الإلكترونى",
    birthDate: "تاريخ الميلاد",
    workingDays: "عدد أيام العمل",
    totalWorkingHours: "اجمالي ساعات العمل",
    payrollDay: "الراتب/اليوم",
    expectedPayroll: "الراتب المتوقع",
    iban: "رقم الحساب المصرفي الدولي",
    signature: "التوقيع",
    stcNumber: "رقم إس تي سي",
  },
};

export default timeSheet;
